import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=4d7f7c5a&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserAgreement.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=4d7f7c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7f7c5a",
  null
  
)

export default component.exports